interface RadioFilterOption {
  value: string;
  label: string;
}

interface RadioFilterProps {
  options: RadioFilterOption[];
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
}

export function RadioFilter({
  options,
  value,
  onChange,
  onClear,
}: RadioFilterProps) {
  const hasFilter = value !== "" && value !== options[0]?.value;

  return (
    <div className="min-w-[14rem] max-w-[20rem]">
      <div className={`space-y-0.5 ${options.length > 8 ? "max-h-48 overflow-y-auto" : ""}`}>
        {options.map((opt) => (
          <label
            key={opt.value}
            className="flex cursor-pointer items-center gap-2 rounded px-1 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
          >
            <input
              type="radio"
              name="radio-filter"
              checked={value === opt.value}
              onChange={() => onChange(opt.value)}
              className="h-3.5 w-3.5 accent-primary-800"
            />
            {opt.label}
          </label>
        ))}
      </div>
      {hasFilter && (
        <div className="mt-2 border-t border-gray-100 pt-2 text-right">
          <button
            onClick={onClear}
            className="text-xs text-gray-500 hover:text-gray-700"
          >
            Išvalyti
          </button>
        </div>
      )}
    </div>
  );
}
